import { type FC, Fragment } from 'react';
import { diffText } from '@/shared/lib';

/**
 * Оформление добавленного правкой текста. Вынесено рядом с компонентом: сравнение версий
 * показывается и текстом, и поверх разметки комментария — оформление у них общее.
 * Боковой зазор нужен там, где добавленное упирается в убранное без пробела между ними.
 */
export const TEXT_DIFF_ADDED_CLASS = 'mx-0.5 px-0.5 bg-warning text-warning-foreground';

/** Оформление убранного правкой текста */
export const TEXT_DIFF_REMOVED_CLASS = 'mx-0.5 text-muted-foreground';

/**
 * Межстрочный интервал текста со сравнением. Подсветка выше строки текста, поэтому на обычном
 * интервале подсветка соседних строк смыкается: нижняя перекрывает верхнюю, и от выделения
 * остаётся полоса поверх текста. Задаётся тексту целиком, а не подсвеченному куску, — иначе
 * строки со сравнением стали бы выше соседних.
 */
export const TEXT_DIFF_LEADING_CLASS = 'leading-relaxed';

type Props = {
  /** Версия до правки */
  previous: string;
  /** Версия после правки */
  next: string;
};

/**
 * Сравнение двух версий текста: убранное перечёркнуто, добавленное подсвечено,
 * совпавшее показано обычным текстом. Переносы строк сохраняются.
 */
export const TextDiff: FC<Props> = ({ previous, next }) => (
  <span className={TEXT_DIFF_LEADING_CLASS}>
    {diffText(previous, next).map((fragment, index) => {
      const lines = fragment.text.split('\n').map((line, lineIndex) => (
        <Fragment key={lineIndex}>
          {lineIndex > 0 && <br />}
          {line}
        </Fragment>
      ));

      if (fragment.kind === 'added')
        return (
          <mark key={index} className={TEXT_DIFF_ADDED_CLASS}>
            {lines}
          </mark>
        );
      if (fragment.kind === 'removed')
        return (
          <s key={index} className={TEXT_DIFF_REMOVED_CLASS}>
            {lines}
          </s>
        );
      return <Fragment key={index}>{lines}</Fragment>;
    })}
  </span>
);
